/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SyncIdentityProviderConnectionApplicationsRequestBody,
  SyncIdentityProviderConnectionApplicationsRequestBody$Outbound,
  SyncIdentityProviderConnectionApplicationsRequestBody$outboundSchema,
} from "../components/syncidentityproviderconnectionapplicationsrequestbody.js";

export type SyncIdentityProviderConnectionApplicationsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SyncIdentityProviderConnectionApplicationsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  syncIdentityProviderConnectionApplicationsRequestBody:
    SyncIdentityProviderConnectionApplicationsRequestBody;
};

/** @internal */
export type SyncIdentityProviderConnectionApplicationsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SyncIdentityProviderConnectionApplicationsSecurity$outboundSchema:
  z.ZodMiniType<
    SyncIdentityProviderConnectionApplicationsSecurity$Outbound,
    SyncIdentityProviderConnectionApplicationsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function syncIdentityProviderConnectionApplicationsSecurityToJSON(
  syncIdentityProviderConnectionApplicationsSecurity:
    SyncIdentityProviderConnectionApplicationsSecurity,
): string {
  return JSON.stringify(
    SyncIdentityProviderConnectionApplicationsSecurity$outboundSchema.parse(
      syncIdentityProviderConnectionApplicationsSecurity,
    ),
  );
}

/** @internal */
export type SyncIdentityProviderConnectionApplicationsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SyncIdentityProviderConnectionApplicationsRequestBody:
    SyncIdentityProviderConnectionApplicationsRequestBody$Outbound;
};

/** @internal */
export const SyncIdentityProviderConnectionApplicationsRequest$outboundSchema:
  z.ZodMiniType<
    SyncIdentityProviderConnectionApplicationsRequest$Outbound,
    SyncIdentityProviderConnectionApplicationsRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      syncIdentityProviderConnectionApplicationsRequestBody:
        SyncIdentityProviderConnectionApplicationsRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        syncIdentityProviderConnectionApplicationsRequestBody:
          "SyncIdentityProviderConnectionApplicationsRequestBody",
      });
    }),
  );

export function syncIdentityProviderConnectionApplicationsRequestToJSON(
  syncIdentityProviderConnectionApplicationsRequest:
    SyncIdentityProviderConnectionApplicationsRequest,
): string {
  return JSON.stringify(
    SyncIdentityProviderConnectionApplicationsRequest$outboundSchema.parse(
      syncIdentityProviderConnectionApplicationsRequest,
    ),
  );
}
